import React, { useEffect, useState } from "react";
import Select from "react-select";
import Button from "../global/Button";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { Controller, useForm } from "react-hook-form";
import Controll from "../academy/Controll";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import ValidateError from "../global/ValidateError";
import DateInput from "../global/DateInput";
import { getFormatedDate, toastMessage } from "../../utils/utils";
import MultiSearchableSelect from "../global/MultiSearchableSelect";
import {
  useCreateWalletMutation,
  useEditWalletMutation,
  useGetAllPlayersQuery,
  useGetAllWalletQuery,
  useGetAllWalletServicesQuery,
  useGetWalletByIdQuery,
} from "../../lib/redux/services/sections/Customers";
import { CURRENCY } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useGetAllClubsByNameQuery } from "../../lib/redux/services/sections/Clubs";
import { changeViewMode } from "../../lib/redux/slices/controlSlice";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import SelectPlayerBox from "../booking/SelectPlayerBox";
import { useGetAllPaymentMethodsQuery } from "../../lib/redux/services/sections/Payments";
type props = {
  type: "new" | "edit" | "duplicate" | "view";
  rowId?: number;
  removeAnimation?: () => void;
  rowData: any;
};
const hiddenPayments = ["is_app","is_multiple","is_voucher","is_payment_link"]
type FormType = {
  name: string;
  amount: number;
  bonus_type: "percentage" | "value";
  bonus: number;
  expiry_date: string;
  expiry_number: number;
  expiry_unit: string;
  service_ids: number[];
  club_ids: number[];
  allowed_payment: "club" | "both";
  voucher_type:"private"|'public'
  player_id:number
  payment_method_id:number
};
function WalletForm({ type, rowId, removeAnimation, rowData }: props) {
  const { shared, inputs } = useGetDictionary();
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const orgId = useSelector((state: any) => state.user.user?.org_id);
  console.log(orgId);

  const club_id = useSelector((state: any) => state.user.selectedClub);
  const { data, isFetching, isLoading, isSuccess } = useGetWalletByIdQuery(
    {
      club_id,
      wallet_id: rowId,
    },
    {
      skip: !rowId,
    }
  );
  const [createWallet] = useCreateWalletMutation();
  const [editWallet] = useEditWalletMutation();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    trigger,
    watch,
    getValues,
  } = useForm<FormType>({
    disabled: type == "view" ? true : false,
    defaultValues: {},
  });
  const handleOption = (options: any) => {
    const selectedMethod = watch("service_ids") || [];
    if (selectedMethod?.includes(7)) {
      return options.filter((item: any) => item.id == 7);
    } else if (!selectedMethod.includes(7) && selectedMethod.length !== 0) {
      return options.filter((item: any) => item.id !== 7);
    } else {
      return options;
    }
  };
  const handleOptionsCallback = (options:any)=>{
    
    
    return options.filter((item:any)=> hiddenPayments.every((payment:any)=>!item[payment]))
  }
  const bonusType = watch("bonus_type");
  const voucherType = watch("voucher_type");
  const onSubmit = async (data: any) => {
    try {
      let services = data.service_ids;
      if (services.includes(7)) {
        services = options
          //@ts-ignore
          .filter((option) => option.id !== 7)
          //@ts-ignore
          .map((item) => item.id);
      }

      if (type === "new" || type === "duplicate") {
        await toast.promise(
          createWallet({
            data: {
              ...data,
              service_ids: services,
            },
            club_id,
          })
            .unwrap()
            .then(() => {
              removeAnimation?.();
            }),
          toastMessage()
        );
      }
      if (type === "edit") {
        console.log(data);

        await toast.promise(
          editWallet({
            data: {
              ...data,
              service_ids: services,
            },
            club_id,
            wallet_id: rowId,
          })
            .unwrap()
            .then(() => {
              removeAnimation?.();
            }),
          toastMessage()
        );
      }
    } catch (error) {
      removeAnimation?.();
    }
  };
  useEffect(() => {
    if (isSuccess && data) {
      reset({ ...data?.data, service_ids: data?.data?.services });
    }
  }, [data, isSuccess]);
  useEffect(() => {
    //@ts-ignore
    dispatch(changeViewMode(type === "view"));
  }, [type]);

  return (
    <div className="w-full px-6 py-8 flex flex-col gap-4 dark:bg-primary h-full">
      <form
        className="w-full h-full flex flex-col justify-between"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex w-full gap-8 flex-col ">
          <div className='w-full flex-1'>
            <Controller
              control={control}
              name="name"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <Input
                    inputProps={{
                      ...field,
                      readOnly: type == "view",
                    }}
                    customClass={type == "view" ? "bg-[#f3f3f3]" : ""}
                    label="Voucher name"
                    isRequired={true}
                  />
                </>
              )}
            />
          </div>
            <div className="w-full flex-1">
                        <label className="block text-sm mb-2">
                          Voucher type
                          <span className="text-red-500">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="voucher_type"
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Select
                              components={{ IndicatorSeparator: () => null }}
                              {...field}
                              isDisabled={type == "view"}
                              styles={selectStyle}
                              classNamePrefix="react-select"
                              theme={selectTheme}
                             
                              options={[
                                { label: "Public", value: "public" },
                                { label: "Private", value: "private" },
                              ]}
                              onChange={(selected) => {
                               
          
                                // @ts-ignore only
                                field.onChange(selected ? selected.value : null);
                              }}
                              value={
                                [
                                  { label: "Public", value: "public" },
                                  { label: "Private", value: "private" },
                                ].find((option) => option.value === field.value) || null
                              }
                            />
                          )}
                        />
                        {errors.voucher_type && (
                          <p className="text-red-500">{"this field is required"}</p>
                        )}
                      </div>
            {voucherType === 'private' && <div className="flex-1 w-full">
                         <label className="block text-sm mb-2 text-primary dark:text-white">
                            Select player
                            
                          </label>
                        <Controller
                          name="player_id"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                           <SelectPlayerBox
                                               field={field}
                                               hasGuestAction={false}
                                               name="player_id"
                                               index={0}
                                               isDisabled={type == "view"}
                                               isCustomOption={true}
                                               extraParams={{
                                                 limit: 50,
                                               }}
                                               HasMenu={
                                                 false
                                               }
                                               setValue={setValue}
                                               requestFn={useGetAllPlayersQuery}
                                               onChange={(selected: any) => {
                                                 setValue("player_id", selected.id);
                                               }}
                                               //@ts-ignore
                                               
                                               isPlayersSelect={true}
                                             />
                          )}
                        />
                      </div>}
                      {voucherType === 'private' &&  <div className="w-full flex-1">
            <label className="block text-sm mb-2">
              Payments method
              <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              rules={{ required: true }}
              name="payment_method_id"
              render={({ field, fieldState: { error } }) => (
                <>
                  <MultiSearchableSelect
                    field={field}
                    fetchFunction={useGetAllPaymentMethodsQuery}
                    valueKey="id"
                    labelKey={"name"}
                    isDisabled={type == "view"}
                    pathParams={{
                      id:club_id,
                      enabled:1
                    }}
                    handleOption={handleOptionsCallback}
                    isMulti={false}
                  />
                  {error && <ValidateError />}
                </>
              )}
            />
          </div>}
          <div className='className="w-full flex-1'>
            <Controller
              control={control}
              name="amount"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <Input
                    inputProps={{
                      ...field,
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },
                    }}
                    customClass={type == "view" ? "bg-[#f3f3f3]" : ""}
                    label="Define values"
                    isRequired={true}
                  />
                </>
              )}
            />
          </div>
          <div className="w-full">
            <Controller
              name="bonus_type"
              control={control}
              rules={{ required: "Privacy is required" }}
              render={({ field }) => (
                <div className="flex flex-row items-center gap-8">
                  <label className="text-sm font-bold text-primary dark:text-white">
                    Bonus Type
                  </label>
                  <RadioInput
                    isDisabled={type == "view"}
                    labelStyle="text-primary dark:text-white"
                    value="percentage"
                    label={"percentage"}
                    checked={field.value === "percentage"}
                    onChange={field.onChange}
                  />
                  <RadioInput
                    isDisabled={type == "view"}
                    labelStyle="text-primary dark:text-white"
                    value="value"
                    label={"value"}
                    checked={field.value === "value"}
                    onChange={field.onChange}
                  />
                </div>
              )}
            />
            {errors.bonus_type && <ValidateError />}
          </div>
          <div className="w-full flex-1">
            <Controller
              control={control}
              name="bonus"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <Input
                    inputProps={{
                      ...field,
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },
                    }}
                    customClass={type == "view" ? "bg-[#f3f3f3]" : ""}
                    label="Bonus"
                    title={bonusType === "percentage" ? "%" : CURRENCY()}
                    isRequired={true}
                  />
                </>
              )}
            />
          </div>

         { <div className="w-full flex-1 flex gap-2  items-center min-w-[250px]">
            {/* <Controller
              name="expiry_date"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <DateInput
                  placeHolder={inputs.date}
                  isDisabled={type == "view"}
                  dateInputProps={{
                    ...field,
                  }}
                  name="expiry_date"
                  title={"Expiry date"}
                  min={getFormatedDate()}
                  //@ts-ignore
                  handleChangeEvent={(e) => {
                    setValue("expiry_date", e.replace("Sept", "Sep"));

                    trigger("expiry_date");
                  }}
                />
              )}
            />

            {errors.expiry_date && errors.expiry_date.type === "required" && (
              <ValidateError />
            )} */}
<div className="w-full">
              <Controller
                control={control}
                name="expiry_number"
                rules={{ required: true }}
                render={({ field }) => (
                  <>
                    <Input
                      inputProps={{
                        ...field,
                        type: "number",
                        onWheel: (e) => {
                          e.preventDefault();
                          //@ts-ignore
                          e.target.blur();
                        },
                      }}
                      customClass={type == "view" ? "bg-[#f3f3f3]" : ""}
                      label="Expiry number"
                      isRequired={true}
                    />
                  </>
                )}
              />
            </div>

            <div className="w-full">
              <label className=" text-sm mb-2 flex whitespace-nowrap ">
                {"Expiry unit "}
                <span className="text-red-500">*</span>
              </label>
              <Controller
                control={control}
                name="expiry_unit"
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    {...field}
                    name="billing_cycle_per"
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    theme={selectTheme}
                    options={[
                      { label: "day", value: "day" },
                      { label: inputs.month, value: "month" },
                      { label: inputs.year, value: "year" },
                    ]}
                    onChange={(selected) => {
                      // @ts-ignore only
                      field.onChange(selected ? selected.value : null);
                    }}
                    value={
                      [
                        { label: "day", value: "day" },
                        { label: inputs.month, value: "month" },
                        { label: inputs.year, value: "year" },
                      ].find((option) => option.value === field.value) || null
                    }
                  />
                )}
              />
            </div>
          </div>}
          <div className="w-full flex-1 min-w-[250px]">
            <label className="block text-sm mb-2">
              Allowed services <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name="service_ids"
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <MultiSearchableSelect
                    fetchFunction={useGetAllWalletServicesQuery}
                    field={field}
                    valueKey="id"
                    pathParams={{
                      org_id: orgId,
                    }}
                    position="top"
                    isDisabled={type == "view"}
                    handleOption={handleOption}
                    AfterLoading={(options: any) => {
                      console.log(options);

                      setOptions(options);
                    }}
                    addOption={{
                      id: 7,
                      name: "Select All",
                    }}
                  />
                  {error && <ValidateError />}
                </>
              )}
            />
          </div>
        {voucherType === 'public' &&<div className="w-full flex-1 min-w-[250px]">
            <label className="block text-sm mb-2">
              Allowed clubs <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name="club_ids"
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <MultiSearchableSelect
                    fetchFunction={useGetAllClubsByNameQuery}
                    field={field}
                    valueKey="id"
                    isDisabled={type == "view"}
                    position="top"
                  />
                  {error && <ValidateError />}
                </>
              )}
            />
          </div>}
          {voucherType === 'public' && <div>
            <div className="flex-1 flex h-full items-center">
              <Controller
                name="allowed_payment"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <div className="flex flex-row items-center gap-8">
                    <label className=" font-bold text-primary dark:text-white">
                      {inputs.status}
                    </label>
                    <RadioInput
                      value="club"
                      name="state"
                      label={inputs.admins_only}
                      isDisabled={type == "view"}
                      labelStyle="text-primary dark:text-white"
                      checked={field.value === "club"}
                      onChange={field.onChange}
                    />
                    <RadioInput
                      value="both"
                      name="state"
                      label={inputs.app_also}
                      checked={field.value === "both"}
                      labelStyle="text-primary dark:text-white"
                      onChange={field.onChange}
                      isDisabled={type == "view"}
                    />
                  </div>
                )}
              />
            </div>
            {errors.allowed_payment && <ValidateError />}
          </div>}
        </div>

        <div className="flex gap-4 justify-end items-center w-full ml-auto mr-0 mobile:gap-8 z-[60] py-5">
          <Button
            customeStyle="text-red-500 w-full mobile:w-[120px] border-primaryRed border p-3 rounded-full"
            text={shared.cancel}
            type="button"
            width="w-full"
            onClick={(e) => {
              e.preventDefault();
              removeAnimation?.();
            }}
          />
          {type != "view" && (
            <Button
              customeStyle="bg-primary text-white dark:bg-primaryYellow dark:text-primary p-3 px-2 rounded-full w-full mobile:w-[120px]"
              text={shared.save}
              type="submit"
              width="w-full"
            />
          )}
        </div>
      </form>
    </div>
  );
}

export default WalletForm;
